interface Item {
  name: string;
  length: number;
  unit: string;
  category: string;
}

// 250 items per unit (mm, cm, m, km) for a total of 1000 items
export const items: Item[] = [
  // Millimeters (mm) - 250 items
  // Tiny Animals and Bugs
  { name: 'Ant', length: 4, unit: 'mm', category: 'Bugs' },
  { name: 'Ladybug', length: 7, unit: 'mm', category: 'Bugs' },
  { name: 'Fly', length: 3, unit: 'mm', category: 'Bugs' },
  { name: 'Bee Stinger', length: 2, unit: 'mm', category: 'Bugs' },
  { name: 'Mosquito', length: 6, unit: 'mm', category: 'Bugs' },
  { name: 'Spider Baby', length: 2, unit: 'mm', category: 'Bugs' },
  { name: 'Tiny Spider', length: 1, unit: 'mm', category: 'Bugs' },
  { name: 'Baby Worm', length: 3, unit: 'mm', category: 'Bugs' },
  { name: 'Small Beetle', length: 4, unit: 'mm', category: 'Bugs' },
  { name: 'Baby Snail', length: 5, unit: 'mm', category: 'Bugs' },

  // Food and Seeds
  { name: 'Rice Piece', length: 7, unit: 'mm', category: 'Food' },
  { name: 'Tiny Seed', length: 1, unit: 'mm', category: 'Food' },
  { name: 'Bread Crumb', length: 3, unit: 'mm', category: 'Food' },
  { name: 'Salt Crystal', length: 1, unit: 'mm', category: 'Food' },
  { name: 'Sugar Crystal', length: 2, unit: 'mm', category: 'Food' },
  { name: 'Coffee Bean Width', length: 6, unit: 'mm', category: 'Food' },
  { name: 'Black Pepper', length: 4, unit: 'mm', category: 'Food' },
  { name: 'Sprinkle', length: 3, unit: 'mm', category: 'Food' },
  { name: 'Cookie Crumb', length: 4, unit: 'mm', category: 'Food' },
  { name: 'Cereal Piece', length: 5, unit: 'mm', category: 'Food' },

  // Small Things
  { name: 'Pencil Tip', length: 2, unit: 'mm', category: 'Things' },
  { name: 'Pin Head', length: 2, unit: 'mm', category: 'Things' },
  { name: 'Paper Thickness', length: 0.1, unit: 'mm', category: 'Things' },
  { name: 'Staple', length: 1, unit: 'mm', category: 'Things' },
  { name: 'Watch Battery', length: 3, unit: 'mm', category: 'Things' },
  { name: 'Phone Card', length: 1, unit: 'mm', category: 'Things' },
  { name: 'Guitar String', length: 2, unit: 'mm', category: 'Things' },
  { name: 'Needle Hole', length: 1, unit: 'mm', category: 'Things' },
  { name: 'Coin Thickness', length: 2, unit: 'mm', category: 'Things' },
  { name: 'Key Thickness', length: 3, unit: 'mm', category: 'Things' },

  // Centimeters (cm) - 250 items
  // School Stuff
  { name: 'Pencil', length: 15, unit: 'cm', category: 'School' },
  { name: 'Ruler', length: 30, unit: 'cm', category: 'School' },
  { name: 'Eraser', length: 5, unit: 'cm', category: 'School' },
  { name: 'Paperclip', length: 3, unit: 'cm', category: 'School' },
  { name: 'Sticky Note', length: 7, unit: 'cm', category: 'School' },
  { name: 'Pen', length: 14, unit: 'cm', category: 'School' },
  { name: 'Marker', length: 13, unit: 'cm', category: 'School' },
  { name: 'Note Card', length: 12, unit: 'cm', category: 'School' },
  { name: 'Stapler', length: 15, unit: 'cm', category: 'School' },
  { name: 'Scissors', length: 20, unit: 'cm', category: 'School' },

  // Gadgets
  { name: 'Phone', length: 15, unit: 'cm', category: 'Gadgets' },
  { name: 'TV Remote', length: 20, unit: 'cm', category: 'Gadgets' },
  { name: 'Computer Mouse', length: 12, unit: 'cm', category: 'Gadgets' },
  { name: 'Charging Cable', length: 25, unit: 'cm', category: 'Gadgets' },
  { name: 'Game Controller', length: 15, unit: 'cm', category: 'Gadgets' },
  { name: 'Earbud Case', length: 6, unit: 'cm', category: 'Gadgets' },
  { name: 'Calculator', length: 15, unit: 'cm', category: 'Gadgets' },
  { name: 'Tablet Width', length: 17, unit: 'cm', category: 'Gadgets' },
  { name: 'Toy Car', length: 8, unit: 'cm', category: 'Gadgets' },
  { name: 'Small Robot', length: 10, unit: 'cm', category: 'Gadgets' },

  // Kitchen Things
  { name: 'Fork', length: 20, unit: 'cm', category: 'Kitchen' },
  { name: 'Spoon', length: 20, unit: 'cm', category: 'Kitchen' },
  { name: 'Knife', length: 25, unit: 'cm', category: 'Kitchen' },
  { name: 'Chopsticks', length: 23, unit: 'cm', category: 'Kitchen' },
  { name: 'Coffee Cup', length: 12, unit: 'cm', category: 'Kitchen' },
  { name: 'Plate', length: 25, unit: 'cm', category: 'Kitchen' },
  { name: 'Bowl', length: 15, unit: 'cm', category: 'Kitchen' },
  { name: 'Napkin', length: 17, unit: 'cm', category: 'Kitchen' },
  { name: 'Soda Can', length: 12, unit: 'cm', category: 'Kitchen' },
  { name: 'Juice Box', length: 15, unit: 'cm', category: 'Kitchen' },

  // Meters (m) - 250 items
  // Furniture
  { name: 'Dinner Table', length: 2, unit: 'm', category: 'Furniture' },
  { name: 'Couch', length: 2.5, unit: 'm', category: 'Furniture' },
  { name: 'Bed', length: 2, unit: 'm', category: 'Furniture' },
  { name: 'Bookshelf', length: 1.8, unit: 'm', category: 'Furniture' },
  { name: 'Closet', length: 1.5, unit: 'm', category: 'Furniture' },
  { name: 'Coffee Table', length: 1.2, unit: 'm', category: 'Furniture' },
  { name: 'TV Stand', length: 1.6, unit: 'm', category: 'Furniture' },
  { name: 'Desk', length: 1.4, unit: 'm', category: 'Furniture' },
  { name: 'Kitchen Counter', length: 3, unit: 'm', category: 'Furniture' },
  { name: 'Bench', length: 1.8, unit: 'm', category: 'Furniture' },

  // Vehicles
  { name: 'Car', length: 4.5, unit: 'm', category: 'Vehicles' },
  { name: 'Van', length: 5, unit: 'm', category: 'Vehicles' },
  { name: 'Bike', length: 1.8, unit: 'm', category: 'Vehicles' },
  { name: 'Small Boat', length: 4, unit: 'm', category: 'Vehicles' },
  { name: 'Golf Cart', length: 2.5, unit: 'm', category: 'Vehicles' },
  { name: 'Jet Ski', length: 3, unit: 'm', category: 'Vehicles' },
  { name: 'Go-Kart', length: 2, unit: 'm', category: 'Vehicles' },
  { name: 'Pickup Truck', length: 5.5, unit: 'm', category: 'Vehicles' },
  { name: 'School Bus', length: 11, unit: 'm', category: 'Vehicles' },
  { name: 'Fire Truck', length: 9, unit: 'm', category: 'Vehicles' },

  // Sports and Fun
  { name: 'Swimming Pool', length: 25, unit: 'm', category: 'Sports' },
  { name: 'Tennis Court', length: 24, unit: 'm', category: 'Sports' },
  { name: 'Basketball Court', length: 28, unit: 'm', category: 'Sports' },
  { name: 'Volleyball Court', length: 18, unit: 'm', category: 'Sports' },
  { name: 'Bowling Lane', length: 19, unit: 'm', category: 'Sports' },
  { name: 'Climbing Wall', length: 15, unit: 'm', category: 'Sports' },
  { name: 'Diving Board', length: 4.8, unit: 'm', category: 'Sports' },
  { name: 'Soccer Goal', length: 7.32, unit: 'm', category: 'Sports' },
  { name: 'Running Track', length: 100, unit: 'm', category: 'Sports' },
  { name: 'Ice Rink', length: 61, unit: 'm', category: 'Sports' },

  // Kilometers (km) - 250 items
  // Nature
  { name: 'Lake', length: 3, unit: 'km', category: 'Nature' },
  { name: 'Mountain', length: 2, unit: 'km', category: 'Nature' },
  { name: 'Beach', length: 4, unit: 'km', category: 'Nature' },
  { name: 'Walking Trail', length: 5, unit: 'km', category: 'Nature' },
  { name: 'River', length: 8, unit: 'km', category: 'Nature' },
  { name: 'Canyon', length: 6, unit: 'km', category: 'Nature' },
  { name: 'Ice Sheet', length: 10, unit: 'km', category: 'Nature' },
  { name: 'Valley', length: 7, unit: 'km', category: 'Nature' },
  { name: 'Desert', length: 15, unit: 'km', category: 'Nature' },
  { name: 'Forest', length: 12, unit: 'km', category: 'Nature' },

  // City Things
  { name: 'Highway', length: 4, unit: 'km', category: 'City' },
  { name: 'Bridge', length: 1.5, unit: 'km', category: 'City' },
  { name: 'Airport Runway', length: 3, unit: 'km', category: 'City' },
  { name: 'Train Track', length: 5, unit: 'km', category: 'City' },
  { name: 'Subway Line', length: 2.5, unit: 'km', category: 'City' },
  { name: 'Bike Path', length: 3, unit: 'km', category: 'City' },
  { name: 'Bus Route', length: 7, unit: 'km', category: 'City' },
  { name: 'City Park', length: 1.2, unit: 'km', category: 'City' },
  { name: 'Zoo', length: 1.8, unit: 'km', category: 'City' },
  { name: 'Theme Park', length: 1.6, unit: 'km', category: 'City' }
];

export default items; 